/**
 * 客户端标识服务。
 *
 * 为登录/注册等请求附带一个稳定的客户端标识（持久化在 localStorage），
 * 便于后端做设备维度的风控/统计。后端未识别该头时会忽略，不影响主流程。
 */

const CLIENT_ID_KEY = 'client_identity_id'

/** 生成一个客户端标识（优先 crypto.randomUUID，降级到时间戳+随机串）。 */
function generateClientId(): string {
  try {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID()
    }
  } catch {
    /* ignore，走降级 */
  }
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`
}

/** 获取（或首次生成并持久化）客户端标识。 */
export function getClientId(): string {
  try {
    let id = localStorage.getItem(CLIENT_ID_KEY)
    if (!id) {
      id = generateClientId()
      localStorage.setItem(CLIENT_ID_KEY, id)
    }
    return id
  } catch {
    // localStorage 不可用时返回临时标识（不持久化）
    return generateClientId()
  }
}

/**
 * 返回随请求发送的客户端标识请求头。
 * 异步签名以兼容未来可能引入的异步指纹采集。
 */
export async function getClientIdentityHeaders(): Promise<Record<string, string>> {
  return {
    'X-Client-Id': getClientId(),
  }
}
